//src/services/qrcode/generator.ts

import QRCode from 'qrcode';

export class QRCodeGenerator {
  static async generateQRCode(url: string): Promise<string> {
    try {
      return await QRCode.toString(url, {
        type: 'svg',
        errorCorrectionLevel: 'H',
        margin: 1,
        width: 1024,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      });
    } catch (error) {
      throw new Error(`Failed to generate QR code: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  static async generateDefaultQRCode(category: string): Promise<string> {
    const defaultSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
      <rect width="100" height="100" fill="#f0f0f0"/>
      <text x="50" y="50" text-anchor="middle" dy=".3em" font-family="Arial">
        ${category.toUpperCase()}
      </text>
    </svg>`;
    return defaultSvg;
  }

  static async generatePlaceholderSVG(): Promise<string> {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
      <rect width="100" height="100" fill="#f0f0f0"/>
      <text x="50" y="50" text-anchor="middle" dy=".3em" font-family="Arial">
        PLACEHOLDER
      </text>
    </svg>`;
  }

  static async generateQRCodeWithLogo(url: string, logoUrl?: string): Promise<string> {
    try {
      const qrSvg = await this.generateQRCode(url);
      
      if (!logoUrl) {
        return qrSvg;
      }

      // Add logo to center of QR code
      const svgWithLogo = qrSvg.replace('</svg>', `
        <image 
          href="${logoUrl}" 
          x="384" 
          y="384" 
          width="256" 
          height="256" 
          preserveAspectRatio="xMidYMid meet"
        />
        </svg>
      `);

      return svgWithLogo;
    } catch (error) {
      throw new Error(`Failed to generate QR code with logo: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}